import React from 'react';

const Context = React.createContext<{ grievanceNumber?: string }>({});

export default Context;
